webpackJsonp([260090145313856],{

/***/ 353:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Finance = function (_Component) {
	  _inherits(Finance, _Component);
	
	  function Finance() {
	    _classCallCheck(this, Finance);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  Finance.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'div',
	        { className: 'insid-header activity-header', style: { marginTop: '100px' } },
	        _react2.default.createElement(
	          'div',
	          { className: 'container' },
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-lg-12' },
	              _react2.default.createElement(
	                'div',
	                { className: 'insid-header-text activity-header-text' },
	                _react2.default.createElement(
	                  'h1',
	                  { className: 'wow fadeIn', 'data-wow-duration': '.2s', 'data-wow-delay': '.1s' },
	                  'Finanza e Tesoreria'
	                )
	              )
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'section',
	        { className: 'activity about2' },
	        _react2.default.createElement(
	          'div',
	          { className: 'container' },
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-sm-12 col-lg-12' },
	              _react2.default.createElement(
	                'div',
	                { className: 'activity-text wow fadeIn animated', 'data-wow-duration': '.5s', 'data-wow-delay': '.2s' },
	                _react2.default.createElement(
	                  'h2',
	                  { className: 'activity-h2' },
	                  'Dettagli'
	                ),
	                _react2.default.createElement(
	                  'ul',
	                  null,
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    'Supporto nella gestione e nel monitoraggio della ',
	                    _react2.default.createElement(
	                      'b',
	                      null,
	                      'finanza'
	                    ),
	                    ' a breve.'
	                  ),
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    'Supporto nella gestione dei rapporti con banche ed istituzioni finanziarie.'
	                  ),
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    'Attivit\xE0 di advisory in relazione ad interventi di ristrutturazione:'
	                  ),
	                  _react2.default.createElement(
	                    'li',
	                    { className: 'list-none' },
	                    _react2.default.createElement(
	                      'ul',
	                      { className: 'list-square' },
	                      _react2.default.createElement(
	                        'li',
	                        null,
	                        'supporto nello sviluppo di piani di ',
	                        _react2.default.createElement(
	                          'b',
	                          null,
	                          'ristrutturazione'
	                        ),
	                        ' del business.'
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    'sviluppo della documentazione di supporto sia per esigenze interne che di dialogo con il sistema bancario e finanziario:'
	                  ),
	                  _react2.default.createElement(
	                    'li',
	                    { className: 'list-none' },
	                    _react2.default.createElement(
	                      'ul',
	                      { className: 'list-square' },
	                      _react2.default.createElement(
	                        'li',
	                        null,
	                        'Piano economico e patrimoniale comprensivo di indicatori e commenti esplicativi.'
	                      ),
	                      _react2.default.createElement(
	                        'li',
	                        null,
	                        'Piano di fattibilit\xE0 finanziario con sviluppo analitico dei flussi finanziari.'
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return Finance;
	}(_react.Component);
	
	exports.default = Finance;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-finance-it-js-490bfd6e625dba54538e.js